import logger from 'utils/logger.util';

const L = logger('fromMoneyStringToNumber'); // eslint-disable-line no-unused-vars

const fromMoneyStringToNumber = (moneyString) => {
  try {
    const stringed = String(moneyString);

    if (stringed !== moneyString) {
      L.debug('()', 'Expected string, instead of', moneyString, 'Will convert it to string first');
    }

    return parseFloat(stringed.substr(1).replace(/,/g, ''));
  } catch (e) {
    L.warn('()', e);
    return NaN;
  }
};

export default fromMoneyStringToNumber;
